import Aviso from "@/Pages/Avisos/index.vue";
import NewEditAviso from "@/Pages/Avisos/newEditAvisos.vue";
import AvisosPortalAluno from "@/Pages/Avisos/avisosPortalAluno.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/avisos/index",
    name: "avisos.index",
    component: Aviso,
    beforeEnter: checkPermission(["avisos.listar"]),
  },
  {
    path: "/avisos/portal",
    name: "avisos.portal",
    component: AvisosPortalAluno,
  },
  {
    path: "/avisos/create",
    name: "avisos.create",
    component: NewEditAviso,
    beforeEnter: checkPermission(["avisos.listar"]),
  },
  {
    path: "/avisos/edit/:aviso_id",
    name: "avisos.edit",
    component: NewEditAviso,
    props: { editing: true },
    beforeEnter: checkPermission(["avisos.listar"]),
  },
];
